import { render, staticRenderFns } from "./MonthEdit.vue?vue&type=template&id=520f9701&scoped=true"
import script from "./MonthEdit.vue?vue&type=script&lang=ts"
export * from "./MonthEdit.vue?vue&type=script&lang=ts"
import style0 from "./MonthEdit.vue?vue&type=style&index=0&id=520f9701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f9701",
  null
  
)

export default component.exports